import { useRecoilState } from 'recoil'
import { selectedGameState } from '../../../common/atoms/atoms'
import React from 'react'
import { GameCategories } from '../../../common/enums/game-categories'
import BlackFridayCardV2 from '../../products/holiday/BlackFridayCardV2'

type Props = {
  showDecoration?: boolean
}

export default function SeasonProduct({ showDecoration }: Props) {
  const [game] = useRecoilState(selectedGameState)

  function filterProductCard(game: string) {
    // return <MemorialDayCard showDecoration={showDecoration} />
    switch (game) {
      case GameCategories.leagueOfLegends:
        return <BlackFridayCardV2 showDecoration={showDecoration} />
      case GameCategories.valorant:
        return <BlackFridayCardV2 showDecoration={showDecoration} />
      case GameCategories.fortnite:
        return <BlackFridayCardV2 showDecoration={showDecoration} />
      default:
        return <BlackFridayCardV2 showDecoration={showDecoration} />
    }
  }

  return filterProductCard(game?.key)
}
